import { globalWatchError } from 'services/logger';

/**
 * Global watch error - start
 */
globalWatchError();

/**
 * Include Lodash.
 *
 * It's nice having _.* available for rapid development, but we really
 * need to audit our components and convert to imports for used
 * functions.
 */
window._ = require('lodash');

/**
 * We'll load MomentJS to assist with all of our date display requirements.
 */
window.moment = require('moment-timezone');

window.moment.defineLocale('en-short', {
    parentLocale: 'en',
    relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%ds',
        m: '1m',
        mm: '%dm',
        h: '1h',
        hh: '%dh',
        d: '1d',
        dd: '%dd',
        M: '1 month',
        MM: '%d months',
        y: '1y',
        yy: '%dy',
    },
});

window.moment.locale('en');

/**
 * We will now load jQuery and the Bootstrap libraries. While it's frowned upon
 * to use jQuery, we won't shun you for it. Just try to keep it to a minimum.
 */
require('jquery.payment');
require('jquery.phone');
